module.exports = __webpack_public_path__ + "staticcomp/img/cover.a8bbc8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/7/cover.jpg
// module id = QwyF
// module chunks = 39